/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { SovrenOutputValidityCode, SovrenParsingStatus } from "../enums";
export const candidateSovrenSchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  parseStatus: z.nativeEnum(SovrenParsingStatus).nullish(),
  response: 
    z.object({
      info: z.object({
        apiVersion: z.string().nullish(),
        code: z.string().nullish(),
        engineVersion: z.string().nullish(),
        message: z.string().nullish(),
        transactionId: z.string().nullish(),
      }),
      value: z.object({
        conversionMetadata: z.object({
          detectedType: z.string().nullish(),
          documentHash: z.string().nullish(),
          outputValidityCode: z.string().nullish(),
          suggestedFileExtension: z.string().nullish(),
        }),
        conversions: 
          z.object({
            HTML: z.string().nullish(),
            PDF: z.string().nullish(),
            RTF: z.string().nullish(),
            candidateImage: z.string().nullish(),
            candidateImageExtension: z.string().nullish(),
          })
        .nullish(),
        geocodeResponse: 
          z.object({
            code: z.string().nullish(),
            message: z.string().nullish(),
          })
        .nullish(),
        indexingResponse: 
          z.object({
            code: z.string().nullish(),
            message: z.string().nullish(),
          })
        .nullish(),
        parsingMetadata: 
          z.object({
            timedOut: z.boolean().nullish(),
          })
        .nullish(),
        parsingResponse: z.object({
          code: z.string().nullish(),
          message: z.string().nullish(),
        }),
        professionNormalizationResponse: z.object({
          code: z.string().nullish(),
          message: z.string().nullish(),
        }),
        resumeData: z.object({
          achievements: z.array(z.string()).nullish(),
          associations: 
            z.array(
              z.object({
                foundInContext: z.string().nullish(),
                organization: z.string().nullish(),
                role: z.string().nullish(),
              })
            )
          .nullish(),
          certifications: 
            z.array(
              z.object({
                isVariation: z.boolean().nullish(),
                matchedFromList: z.boolean().nullish(),
                name: z.string().nullish(),
              })
            )
          .nullish(),
          contactInformation: 
            z.object({
              candidateName: 
                z.object({
                  familyName: z.string().nullish(),
                  formattedName: z.string().nullish(),
                  givenName: z.string().nullish(),
                  middleName: z.string().nullish(),
                  moniker: z.string().nullish(),
                  prefix: z.string().nullish(),
                  suffix: z.string().nullish(),
                })
              .nullish(),
              emailAddresses: z.array(z.string()).nullish(),
              location: 
                z.object({
                  countryCode: z.string().nullish(),
                  geoCoordinates: 
                    z.object({
                      latitude: z.number().nullish(),
                      longitude: z.number().nullish(),
                      source: z.string().nullish(),
                    })
                  .nullish(),
                  municipality: z.string().nullish(),
                  postalCode: z.string().nullish(),
                  regions: z.array(z.string()).nullish(),
                  streetAddressLines: z.array(z.string()).nullish(),
                })
              .nullish(),
              telephones: 
                z.array(
                  z.object({
                    areaCityCode: z.string().nullish(),
                    internationalCountryCode: z.string().nullish(),
                    normalized: z.string().nullish(),
                    raw: z.string().nullish(),
                    subscriberNumber: z.string().nullish(),
                  })
                )
              .nullish(),
              webAddresses: 
                z.array(
                  z.object({
                    address: z.string().nullish(),
                    type: z.string().nullish(),
                  })
                )
              .nullish(),
            })
          .nullish(),
          coverLetter: z.string().nullish(),
          education: 
            z.object({
              educationDetails: 
                z.array(
                  z.object({
                    degree: 
                      z.object({
                        name: 
                          z.object({
                            normalized: z.string().nullish(),
                            probability: z.string().nullish(),
                            raw: z.string().nullish(),
                          })
                        .nullish(),
                        type: z.string().nullish(),
                      })
                    .nullish(),
                    graduated: 
                      z.object({
                        value: z.boolean().nullish(),
                      })
                    .nullish(),
                    id: z.string().nullish(),
                    lastEducationDate: 
                      z.object({
                        date: z.string().date().nullish(),
                        foundDay: z.boolean().nullish(),
                        foundMonth: z.boolean().nullish(),
                        foundYear: z.boolean().nullish(),
                        isCurrentDate: z.boolean().nullish(),
                      })
                    .nullish(),
                    location: 
                      z.object({
                        countryCode: z.string().nullish(),
                        geoCoordinates: 
                          z.object({
                            latitude: z.number().nullish(),
                            longitude: z.number().nullish(),
                            source: z.string().nullish(),
                          })
                        .nullish(),
                        municipality: z.string().nullish(),
                        postalCode: z.string().nullish(),
                        regions: z.array(z.string()).nullish(),
                        streetAddressLines: z.array(z.string()).nullish(),
                      })
                    .nullish(),
                    majors: z.array(z.string()).nullish(),
                    minors: z.array(z.string()).nullish(),
                    schoolName: 
                      z.object({
                        normalized: z.string().nullish(),
                        probability: z.string().nullish(),
                        raw: z.string().nullish(),
                      })
                    .nullish(),
                    schoolType: z.string().nullish(),
                    text: z.string().nullish(),
                  })
                )
              .nullish(),
              highestDegree: 
                z.object({
                  name: 
                    z.object({
                      normalized: z.string().nullish(),
                      probability: z.string().nullish(),
                      raw: z.string().nullish(),
                    })
                  .nullish(),
                  type: z.string().nullish(),
                })
              .nullish(),
            })
          .nullish(),
          employmentHistory: 
            z.object({
              experienceSummary: 
                z.object({
                  attentionNeeded: z.string().nullish(),
                  averageMonthsPerEmployer: z.number().nullish(),
                  currentManagementLevel: z.string().nullish(),
                  description: z.string().nullish(),
                  executiveType: z.string().nullish(),
                  managementStory: z.string().nullish(),
                  monthsOfManagementExperience: z.number().int().nullish(),
                  monthsOfWorkExperience: z.number().int().nullish(),
                })
              .nullish(),
              positions: 
                z.array(
                  z.object({
                    description: z.string().nullish(),
                    employer: 
                      z.object({
                        location: 
                          z.object({
                            countryCode: z.string().nullish(),
                            geoCoordinates: 
                              z.object({
                                latitude: z.number().nullish(),
                                longitude: z.number().nullish(),
                                source: z.string().nullish(),
                              })
                            .nullish(),
                            municipality: z.string().nullish(),
                            postalCode: z.string().nullish(),
                            regions: z.array(z.string()).nullish(),
                            streetAddressLines: z.array(z.string()).nullish(),
                          })
                        .nullish(),
                        name: 
                          z.object({
                            normalized: z.string().nullish(),
                            probability: z.string().nullish(),
                            raw: z.string().nullish(),
                          })
                        .nullish(),
                        otherFoundName: 
                          z.object({
                            normalized: z.string().nullish(),
                            probability: z.string().nullish(),
                            raw: z.string().nullish(),
                          })
                        .nullish(),
                      })
                    .nullish(),
                    endDate: 
                      z.object({
                        date: z.string().date().nullish(),
                        foundDay: z.boolean().nullish(),
                        foundMonth: z.boolean().nullish(),
                        foundYear: z.boolean().nullish(),
                        isCurrentDate: z.boolean().nullish(),
                      })
                    .nullish(),
                    id: z.string().nullish(),
                    isCurrent: z.boolean().nullish(),
                    isSelfEmployed: z.boolean().nullish(),
                    jobLevel: z.string().nullish(),
                    jobTitle: 
                      z.object({
                        normalized: z.string().nullish(),
                        probability: z.string().nullish(),
                        raw: z.string().nullish(),
                        variations: z.array(z.string()).nullish(),
                      })
                    .nullish(),
                    jobType: z.string().nullish(),
                    normalizedProfession: 
                      z.object({
                        Class: 
                          z.object({
                            codeId: z.string().nullish(),
                            description: z.string().nullish(),
                            version: z.string().nullish(),
                          })
                        .nullish(),
                        ISCO: 
                          z.object({
                            codeId: z.string().nullish(),
                            description: z.string().nullish(),
                            version: z.string().nullish(),
                          })
                        .nullish(),
                        ONET: 
                          z.object({
                            codeId: z.string().nullish(),
                            description: z.string().nullish(),
                            version: z.string().nullish(),
                          })
                        .nullish(),
                        confidence: z.number().nullish(),
                        group: 
                          z.object({
                            codeId: z.string().nullish(),
                            description: z.string().nullish(),
                            version: z.string().nullish(),
                          })
                        .nullish(),
                        profession: 
                          z.object({
                            codeId: z.string().nullish(),
                            description: z.string().nullish(),
                            version: z.string().nullish(),
                          })
                        .nullish(),
                      })
                    .nullish(),
                    relatedToByCompanyName: z.array(z.string()).nullish(),
                    relatedToByDates: z.array(z.string()).nullish(),
                    startDate: 
                      z.object({
                        date: z.string().date().nullish(),
                        foundDay: z.boolean().nullish(),
                        foundMonth: z.boolean().nullish(),
                        foundYear: z.boolean().nullish(),
                        isCurrentDate: z.boolean().nullish(),
                      })
                    .nullish(),
                    subTaxonomyName: z.string().nullish(),
                    taxonomyName: z.string().nullish(),
                    taxonomyPercentage: z.string().nullish(),
                  })
                )
              .nullish(),
            })
          .nullish(),
          hobbies: z.string().nullish(),
          languageCompetencies: 
            z.array(
              z.object({
                foundInContext: z.string().nullish(),
                language: z.string().nullish(),
                languageCode: z.string().nullish(),
              })
            )
          .nullish(),
          licenses: 
            z.array(
              z.object({
                matchedFromList: z.boolean().nullish(),
                name: z.string().nullish(),
              })
            )
          .nullish(),
          militaryExperience: 
            z.array(
              z.object({
                country: z.string().nullish(),
                endDate: 
                  z.object({
                    date: z.string().date().nullish(),
                    foundDay: z.boolean().nullish(),
                    foundMonth: z.boolean().nullish(),
                    foundYear: z.boolean().nullish(),
                    isCurrentDate: z.boolean().nullish(),
                  })
                .nullish(),
                foundInContext: z.string().nullish(),
                service: 
                  z.object({
                    branch: z.string().nullish(),
                    name: z.string().nullish(),
                    rank: z.string().nullish(),
                  })
                .nullish(),
                startDate: 
                  z.object({
                    date: z.string().date().nullish(),
                    foundDay: z.boolean().nullish(),
                    foundMonth: z.boolean().nullish(),
                    foundYear: z.boolean().nullish(),
                    isCurrentDate: z.boolean().nullish(),
                  })
                .nullish(),
              })
            )
          .nullish(),
          objective: z.string().nullish(),
          patents: z.string().nullish(),
          personalAttributes: 
            z.object({
              availability: z.string().nullish(),
              birthplace: z.string().nullish(),
              currentLocation: z.string().nullish(),
              dateOfBirth: 
                z.object({
                  date: z.string().date().nullish(),
                  foundDay: z.boolean().nullish(),
                  foundMonth: z.boolean().nullish(),
                  foundYear: z.boolean().nullish(),
                  isCurrentDate: z.boolean().nullish(),
                })
              .nullish(),
              drivingLicense: z.string().nullish(),
              familyComposition: z.string().nullish(),
              fathersName: z.string().nullish(),
              gender: z.string().nullish(),
              hukouArea: z.string().nullish(),
              hukouCity: z.string().nullish(),
              maritalStatus: z.string().nullish(),
              motherTongue: z.string().nullish(),
              mothersMaidenName: z.string().nullish(),
              nationality: z.string().nullish(),
              passportNumber: z.string().nullish(),
              preferredLocation: z.string().nullish(),
              visaStatus: z.string().nullish(),
              willingToRelocate: z.string().nullish(),
            })
          .nullish(),
          professionalSummary: z.string().nullish(),
          publications: z.string().nullish(),
          references: 
            z.array(
              z.object({
                company: z.string().nullish(),
                emailAddresses: z.array(z.string()).nullish(),
                location: 
                  z.object({
                    countryCode: z.string().nullish(),
                    geoCoordinates: 
                      z.object({
                        latitude: z.number().nullish(),
                        longitude: z.number().nullish(),
                        source: z.string().nullish(),
                      })
                    .nullish(),
                    municipality: z.string().nullish(),
                    postalCode: z.string().nullish(),
                    regions: z.array(z.string()).nullish(),
                    streetAddressLines: z.array(z.string()).nullish(),
                  })
                .nullish(),
                referenceName: 
                  z.object({
                    familyName: z.string().nullish(),
                    formattedName: z.string().nullish(),
                    givenName: z.string().nullish(),
                    middleName: z.string().nullish(),
                    moniker: z.string().nullish(),
                    prefix: z.string().nullish(),
                    suffix: z.string().nullish(),
                  })
                .nullish(),
                telephones: 
                  z.array(
                    z.object({
                      normalized: z.string().nullish(),
                      probability: z.string().nullish(),
                      raw: z.string().nullish(),
                    })
                  )
                .nullish(),
                title: z.string().nullish(),
                webAddresses: 
                  z.array(
                    z.object({
                      address: z.string().nullish(),
                      type: z.string().nullish(),
                    })
                  )
                .nullish(),
              })
            )
          .nullish(),
          resumeMetadata: 
            z.object({
              documentCulture: z.string().nullish(),
              documentLanguage: z.string().nullish(),
              foundSections: 
                z.array(
                  z.object({
                    firstLineNumber: z.number().int().nullish(),
                    headerTextFound: z.string().nullish(),
                    lastLineNumber: z.number().int().nullish(),
                    sectionType: z.string().nullish(),
                  })
                )
              .nullish(),
              parserSettings: z.string().nullish(),
              plainText: z.string().nullish(),
              reservedData: 
                z.object({
                  emailAddresses: z.array(z.string()).nullish(),
                  names: z.array(z.string()).nullish(),
                  otherData: z.array(z.string()).nullish(),
                  phones: z.array(z.string()).nullish(),
                  urls: z.array(z.string()).nullish(),
                })
              .nullish(),
              resumeQuality: 
                z.array(
                  z.object({
                    findings: 
                      z.array(
                        z.object({
                          message: z.string().nullish(),
                          qualityCode: z.string().nullish(),
                          sectionIdentifiers: 
                            z.array(
                              z.object({
                                id: z.string().nullish(),
                                sectionType: z.string().nullish(),
                              })
                            )
                          .nullish(),
                        })
                      )
                    .nullish(),
                    level: z.string().nullish(),
                  })
                )
              .nullish(),
            })
          .nullish(),
          securityCredentials: 
            z.array(
              z.object({
                foundInContext: z.string().nullish(),
                name: z.string().nullish(),
              })
            )
          .nullish(),
          skills: 
            z.object({
              normalized: 
                z.array(
                  z.object({
                    foundIn: 
                      z.array(
                        z.object({
                          id: z.string().nullish(),
                          sectionType: z.string().nullish(),
                        })
                      )
                    .nullish(),
                    id: z.string().nullish(),
                    lastUsed: 
                      z.object({
                        value: z.string().nullish(),
                      })
                    .nullish(),
                    monthsExperience: 
                      z.object({
                        value: z.number().int().nullish(),
                      })
                    .nullish(),
                    name: z.string().nullish(),
                    rawSkills: z.array(z.string()).nullish(),
                    type: z.string().nullish(),
                  })
                )
              .nullish(),
              raw: 
                z.array(
                  z.object({
                    foundIn: 
                      z.array(
                        z.object({
                          id: z.string().nullish(),
                          sectionType: z.string().nullish(),
                        })
                      )
                    .nullish(),
                    lastUsed: 
                      z.object({
                        value: z.string().nullish(),
                      })
                    .nullish(),
                    monthsExperience: 
                      z.object({
                        value: z.number().int().nullish(),
                      })
                    .nullish(),
                    name: z.string().nullish(),
                  })
                )
              .nullish(),
              relatedProfessionClasses: 
                z.array(
                  z.object({
                    groups: 
                      z.array(
                        z.object({
                          id: z.string().nullish(),
                          name: z.string().nullish(),
                          normalizedSkills: z.array(z.string()).nullish(),
                          percent: z.number().int().nullish(),
                        })
                      )
                    .nullish(),
                    id: z.string().nullish(),
                    name: z.string().nullish(),
                    percent: z.number().int().nullish(),
                  })
                )
              .nullish(),
            })
          .nullish(),
          speakingEngagements: z.string().nullish(),
          training: 
            z.object({
              text: z.string().nullish(),
              trainings: 
                z.array(
                  z.object({
                    endDate: 
                      z.object({
                        date: z.string().date().nullish(),
                        foundDay: z.boolean().nullish(),
                        foundMonth: z.boolean().nullish(),
                        foundYear: z.boolean().nullish(),
                        isCurrentDate: z.boolean().nullish(),
                      })
                    .nullish(),
                    entity: z.string().nullish(),
                    qualifications: z.array(z.string()).nullish(),
                    startDate: 
                      z.object({
                        date: z.string().date().nullish(),
                        foundDay: z.boolean().nullish(),
                        foundMonth: z.boolean().nullish(),
                        foundYear: z.boolean().nullish(),
                        isCurrentDate: z.boolean().nullish(),
                      })
                    .nullish(),
                    text: z.string().nullish(),
                  })
                )
              .nullish(),
            })
          .nullish(),
          userDefinedTags: z.array(z.string()).nullish(),
        }),
      }),
    })
  .nullish(),
  updatedAt: z.string().datetime().nullish(),
  validityCode: z.nativeEnum(SovrenOutputValidityCode).nullish(),
});

export type CandidateSovren = z.infer<typeof candidateSovrenSchema>;
